























    import {BTabs} from 'bootstrap-vue';
    import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
    import LocalData from '../mixins/local-data';

    @Component({})
    export default class SideToolbar extends Mixins(LocalData) {
        @Prop() readonly bTabs: BTabs | null = null;
        @Prop() readonly box_width: string = '60px';

        activeIndex: number = 0
        private show = true

        changeIndex(index: number) {
        this.activeIndex = index
    }

    @Watch('bTabs')
    updateBTab(newVal: any, oldVal: any) {
        if (newVal != null && this.bTabs != null) {
            this.bTabs.$on('input', this.changeIndex)
        }
    }

    destroy() {
        if (this.bTabs != null) {
            this.bTabs.off('input', this.changeIndex)
        }
    }

    changeState() {
        this.show = !this.show;
    }
}
